import Toast, { POSITION, TYPE } from 'vue-toastification';
import Vue from 'vue';

const options = {
  timeout: 5000,
  closeButton: false,
  position: POSITION.TOP_CENTER,
  pauseOnFocusLoss: false,
  hideProgressBar: true,
  draggable: false,
  toastDefaults: {
    [TYPE.SUCCESS]: {
      icon: 'far fa-check-circle',
    },
    [TYPE.ERROR]: {
      icon: 'far fa-exclamation-circle',
    },
    [TYPE.INFO]: {
      icon: 'far fa-info-circle',
    },
    [TYPE.WARNING]: {
      icon: 'far fa-exclamation-triangle',
    },
  },
};

Vue.use(Toast, options);

export default class AppMessageUtils {
  static async success(message: string, ignoreSidebar = false) {
    Vue.$toast.clear();
    Vue.$toast.success(message);
    this.handleSidebarClass(ignoreSidebar);
  }

  static async error(message: string, ignoreSidebar = false) {
    Vue.$toast.clear();
    Vue.$toast.error(message);
    this.handleSidebarClass(ignoreSidebar);
  }

  static async info(message: string, timeout = 5000, ignoreSidebar = false) {
    Vue.$toast.clear();
    Vue.$toast.info(message, { timeout });
    this.handleSidebarClass(ignoreSidebar);
  }

  static async warning(message: string, timeout = 5000, ignoreSidebar = false) {
    Vue.$toast.clear();
    Vue.$toast.warning(message, { timeout });
    this.handleSidebarClass(ignoreSidebar);
  }

  static async close() {
    Vue.$toast.clear();
  }

  static handleSidebarClass(ignoreSidebar: boolean) {
    if(ignoreSidebar) {
      this.addNoSidebarClass();
      return;
    }

    this.removeNoSidebarClass();
  }

  static addNoSidebarClass = () => document.querySelector('.Vue-Toastification__container.top-center')?.classList?.add('no-sidebar');
  static removeNoSidebarClass = () => document.querySelector('.Vue-Toastification__container.top-center')?.classList?.remove('no-sidebar');
}
